/** Task text for a time entry row from GET /api/time-entries (task_summary / current_task_label). */
export function taskCellText(entry) {
  if (!entry) return '—';
  if (!entry.clock_out) return entry.current_task_label ? `Now: ${entry.current_task_label}` : '—';
  return entry.task_summary || '—';
}
